<template>
  <base-slide-over ref="slideOver" title="New Document" size="xl">
    <base-form ref="form" class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" v-model="isFormValid">
      <base-text-field label="Name" placeholder="Enter name of document" v-model="values.name" required />
      <base-select label="Type" placeholder="Select document type" :options="documentTypes" v-model="values.type" label-key="label" value-key="value" required />
      <base-text-field label="New Type" v-model="values.newType" required v-show="values.type === 'other'" />
      <FormulateInput
        type="file"
        name="file"
        label="Select your document to upload"
        help="Word (.docx), Powerpoint (.pptx), PDF, PNG, JPG"
        validation="required|mime:application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.presentation,image/jpeg,image/png"
        v-model="document"
      />
    </base-form>
    <inline-error id="file-upload-modal-error" :title="uploadError.errorTitle" :message="uploadError.errorMessage" :error="uploadError.error" />
    <template #fixed-bottom>
      <div class="tw-py-2 tw-px-3 tw-flex tw-justify-end">
        <base-button type="flat" @click="$refs.slideOver.hide()" class="tw-mr-3">Cancel</base-button>
        <base-button @click="sendData" :disabled="!isFormValid" :loading="isFileLoading">Upload</base-button>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import _ from "lodash";
import InlineError from "@/components/InlineError";

export default {
  name: "BusinessMemberDocumentUpload",
  components: {
    InlineError,
  },
  props: {
    businessId: String,
    userId: String,
  },
  data() {
    return {
      isFileLoading: false,
      isFormValid: true,
      uploadError: {
        errorTitle: "",
        errorMessage: "",
        error: null,
      },
      document: null,
      documentTypes: [{ value: "", label: "" }],
      values: {
        name: null,
        type: null,
        newType: null,
        file: null,
      },
    };
  },
  created() {
    this.loadDocumentTypes();
  },
  methods: {
    show() {
      this.$refs.slideOver.show();
      this.$refs.form.reset();
    },
    hide() {
      this.$refs.slideOver.hide();
    },
    async sendData() {
      this.isFileLoading = true;

      let documentType = this.values.type === "other" ? this.values.newType : this.values.type;

      await this.$axios
        .put(`/businesses/${this.businessId}/users/${this.userId}/documents/${this.document.files[0].path.documentId}`, { name: this.values.name, type: documentType })
        .then(() => {
          this.resetForm();
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Document Saved", message: "Your document was uploaded successfully" });
          this.$emit("save");
          this.loadDocumentTypes();
          this.hide();
        })
        .catch((err) => {
          this.uploadError.errorTitle = `Upload failed.`;
          this.uploadError.errorMessage = `The file ${this.values.name} could not be uploaded. Please try again.`;
          this.uploadError.error = err;
        })
        .finally(() => {
          this.isFileLoading = false;
        });
    },
    loadDocumentTypes() {
      this.$axios
        .get(`/businesses/${this.businessId}/documenttypes`)
        .then((res) => {
          this.documentTypes = this.formatDocumentTypes(res.data);
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: "Failed to load document types",
            message: "We had a problem retrieving the list of document types. Please reload the page to try again.",
            error: err,
          });
        });
    },
    formatDocumentTypes(documentTypes) {
      let finalTypes = [];
      for (let documentType of documentTypes) {
        finalTypes.push({ value: documentType, label: _.startCase(_.toLower(documentType)) });
      }
      finalTypes.push({ value: "other", label: "Add New Document Type" });

      var filtered = finalTypes.filter((type) => type.value != "training");
      var filtered2 = filtered.filter((type) => type.value != "training_cover_image");
      return filtered2;
    },
    resetForm() {
      this.values = { name: null, type: null, newType: null, file: null };
      this.document = null;
      this.$refs.form.reset();
    },
  },
};
</script>
